import '!wix-tpa-style-loader?mode=inline!sass-loader?{"includePaths": [".", "node_modules"]}!../../assets/styles/injected-style-gallery.global.scss';
import '../../assets/styles/injected-style-gallery.global.scss';
import './index-gallery.global.scss';
import 'html2canvas'
import 'fontawesome'



// WEBPACK FOOTER //
// ./apps/gallery/externals-gallery.js